import React, { useState } from "react";
import AddButton from "@core/buttons/atoms/AddButton";
import AddModal from "@core/modals/AddModal";
import Input from "@core/inputs/Input";
import CensusService from "@services/CensusService";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";

const CreateCensus = ({ onAdded }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");

  const closeModal = () => {
    setShowModal(false);
    setName("");
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    CensusService.create(name)
      .then(() => {
        showSuccess(t("censusCreatedSuccessfully"));
        setName("");
        onAdded();
        setShowModal(false);
      })
      .catch((err) => {
        showError(err?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <PermissionHandler permission={"create_census"}>
      <AddButton
        label={`${t("add")} ${t("census")}`}
        onClick={() => setShowModal(true)}
      />
      <AddModal
        show={showModal}
        title={`${t("add")} ${t("census")}`}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5 sm:gap-10">
          <Input
            height="h-10"
            label={t("censusName")}
            placeholder={t("censusName")}
            value={name}
            onChange={setName}
          />
        </div>
      </AddModal>
    </PermissionHandler>
  );
};

export default CreateCensus;
